import { useMutation } from "react-query";
import { correctVehiclePolicyStatus } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const correctVehiclePolicyStatusFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: any;
}) => {
  return await correctVehiclePolicyStatus(rowVersion, params);
};

export function useCorrectVehiclePolicyStatus() {
  return useMutation(correctVehiclePolicyStatusFn, {
    mutationKey: MUTATION_KEYS.correctVehiclePolicyStatus,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
